import React, { useState, useEffect } from "react";
import { useFetch } from "../../../../components/common/FetchProvider";
import Loader from "components/Loader/Loader";
import InputField from "components/fields/InputField";


const FunctionsModal = ({ showModal, setModalState, refreshData , employeesData, setEmployeesData}) => {
    const fetchWrapper = useFetch();
    const [errorMessages, setErrorMessages] = useState({});
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({});
    const [error, setError] = useState(false);
    const [organizationData, setOrganizationData] = useState([]);
    const [categoryData, setCategoryData] = useState([]);
    const [formErrorData, setFormErrorData] = useState({});

    const handleInputChange = (event) => {
        errorMessages.message = "";
        setFormErrorData({});
        const {id, value} = event.target;
        setFormData((prevState) => ({
            ...prevState,
            [id]: value,
        }));
    };

    const setErrorForField = (field) => {
        setFormErrorData({[field]: "error"});
    }

    const errors = {
        title: "Please select Tratar",
        name: "Please enter valid Nome do departamento",
        organizationId: "Please select Orgão",
        employeeType: "Please select Tipo de funcionário",
        categoryId: "Please select Categoria",
        status: "Please select Status",
        apiError: "Something went wrong"
    };

    const validationRules = {
        title: {
            validate: (value) => value !== undefined && value !== "",
            message: errors.title,
        },
        name: {
            validate: (value) => value && value.length >= 3,
            message: errors.name,
        },
        organizationId: {
            validate: (value) => value !== undefined && value !== "",
            message: errors.organizationId,
        },
        employeeType: {
            validate: (value) => value !== undefined && value !== "",
            message: errors.employeeType,
        },
        categoryId: {
            validate: (value) => value !== undefined && value !== "",
            message: errors.categoryId,
        },
        status: {
            validate: (value) => value !== undefined && value !== "",
            message: errors.status,
        }
    };

    useEffect(() => {
        fetchData();
        setExistingData(employeesData);
        if (showModal) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
        }
        return () => {
            document.body.style.overflow = "auto";
        };
    }, [showModal, employeesData]);

    const setExistingData = (data) => {
        if (data !== null && data !== undefined && data.id != null) {
            setFormData(data)
        }
    }

    const handleCancel = () => {
        setEmployeesData(null);
        setModalState(false);
    }

    const fetchData = async () => {
        setLoading(true);
        try {
            let organizationrApiUrl = `${process.env.REACT_APP_API_URL}/v1/configuration/organization`;
            const userToken = localStorage.getItem("token");
            const organizationResponse = await fetchWrapper(organizationrApiUrl, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${userToken}`,
                },
            });
            if (organizationResponse.ok) {
                const responseData = await organizationResponse.json();
                if (responseData.data && responseData.data.length > 0) {
                    setOrganizationData(responseData.data);
                } else {
                    setError(true);
                }
            } else {
                setLoading(false);
                setError(true);
                console.error('Error fetching organization API data:', organizationResponse.status);
            }

            let employeeCategoryApiUrl = `${process.env.REACT_APP_API_URL}/v1/configuration/employee-category`;
            const employeeCategoryResponse = await fetchWrapper(employeeCategoryApiUrl, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${userToken}`,
                },
            });
            setLoading(false);
            if (employeeCategoryResponse.ok) {
                const responseData = await employeeCategoryResponse.json();
                if (responseData.data && responseData.data.length > 0) {
                    setCategoryData(responseData.data);
                } else {
                    setError(true);
                }
            } else {
                setLoading(false);
                setError(true);
                console.error('Error fetching employeeCategory API data:', employeeCategoryResponse.status);
            }

        } catch (error) {
            setLoading(false);
            setError(true);
            console.error('Error fetching API data:', error);
        }
    };

    const handleSubmit = () => {
        for (let field in validationRules) {
            const {validate, message} = validationRules[field];
            if (!validate(formData[field])) {
                setErrorMessages({name: field, message: message});
                setErrorForField(field);
                return;
            }
        }

        setLoading(true);
        const requestOptions = {
            method: employeesData != null && employeesData.id !== undefined ? "PUT" : "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + localStorage.getItem("token")
            },
            body: JSON.stringify(formData)
        };

        fetchWrapper(process.env.REACT_APP_API_URL + "/v1/configuration/employee", requestOptions)
            .then((response) => response.json())
            .then((data) => {
                setLoading(false);
                if (data.responseInfo.status === "SUCCESS") {
                    setEmployeesData(null);
                    refreshData();
                    setModalState(false);
                } else {
                    setErrorMessages({
                        name: "apiError",
                        message: errors.apiError,
                    });
                }
            });
    };

    return (
        <>
            {showModal ? (
                <>
                    <Loader show={loading} />
                    <div className="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto overflow-x-hidden outline-none focus:outline-none">
                        <div className="relative my-10 mx-auto w-full max-w-3xl sm:w-4/5 md:w-3/4 lg:w-2/3 xl:w-1/2">
                            <div className="relative font-normal flex flex-col rounded-lg border-0 bg-white text-navy-800 shadow-lg outline-none focus:outline-none dark:!border-white/10 dark:!bg-navy-800 dark:text-white dark:shadow-none">

                                {/* Modal Header */}
                                <div className="flex items-start justify-between rounded-t border-b border-solid p-5 border-slate-200">
                                    <h4 className="text-3xl font-semibold">Adicionar/editar Funcionário</h4>
                                </div>

                                {/* Modal Body */}
                                <div className="p-5 space-y-4" style={{ overflowY: "auto", maxHeight: "70vh" }}>
                                    <div className="text-red-500 min-h-[1.30rem]">{errorMessages.message}</div>

                                    {/* Row 1: Payment Date with Calendar Icon and Document Number */}
                                    <div className="flex space-x-4 items-start">

                                        <div className="w-full">
                                            <label
                                                className="text-sm  dark:text-white ml-1.5 font-medium">Tratar</label>
                                            <select
                                                className={`mt-2 flex h-12 w-full items-center justify-center rounded-xl border bg-white/0 p-3 text-sm outline-none dark:!border-white/10  ${formErrorData.beneficiary === "error" ? "border-red-500" : ""
                                                    }`}
                                                id="title"
                                                value={formData.title}
                                                onChange={handleInputChange}
                                            >
                                                <option value="">Selecione o Tratamento</option>
                                                <option value="Sr.">Sr.</option>
                                                <option value="Sra.">Sra.</option>
                                            </select>
                                        </div>

                                        <div className="w-full">
                                            <div className="relative">
                                                <InputField
                                                    variant="auth"
                                                    label="Nome do departamento"
                                                    id="name"
                                                    type="text"
                                                    state={formErrorData.name === "error" ? "error" : ""}
                                                    value={formData.name}
                                                    onChange={handleInputChange}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="flex space-x-4 items-start">

                                        <div className="w-full">
                                            <label
                                                className="text-sm  dark:text-white ml-1.5 font-medium">Orgão</label>
                                            <select
                                                className={`mt-2 flex h-12 w-full items-center justify-center rounded-xl border bg-white/0 p-3 text-sm outline-none dark:!border-white/10  ${formErrorData.beneficiary === "error" ? "border-red-500" : ""
                                                    }`}
                                                id="organizationId"
                                                value={formData.organizationId}
                                                onChange={handleInputChange}
                                            >
                                                <option value="">Selecione o Orgão</option>
                                                {organizationData.map((organization) => (
                                                    <option key={organization.id} value={organization.id}>
                                                        {organization.name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>



                                    {/* Row 3:  */}
                                    <div className="flex space-x-4 items-start">

                                        <div className="w-full">
                                            <label
                                                className="text-sm  dark:text-white ml-1.5 font-medium">Tipo de funcionário</label>
                                            <select
                                                className={`mt-2 flex h-12 w-full items-center justify-center rounded-xl border bg-white/0 p-3 text-sm outline-none dark:!border-white/10  ${formErrorData.beneficiary === "error" ? "border-red-500" : ""
                                                    }`}
                                                id="employeeType"
                                                value={formData.employeeType}
                                                onChange={handleInputChange}
                                            >
                                                <option value="">Selecione o tipo de funcionário</option>
                                                <option value="Quadro">Quadro</option>
                                                <option value="Local">Local</option>
                                                <option value="Sem tipo">Sem tipo</option>
                                            </select>
                                        </div>

                                        {/* Payment Date Field */}
                                        <div className="w-full">
                                            <label
                                                className="text-sm  dark:text-white ml-1.5 font-medium">Categoria</label>
                                            <select
                                                className={`mt-2 flex h-12 w-full items-center justify-center rounded-xl border bg-white/0 p-3 text-sm outline-none dark:!border-white/10  ${formErrorData.beneficiary === "error" ? "border-red-500" : ""
                                                    }`}
                                                id="categoryId"
                                                value={formData.categoryId}
                                                onChange={handleInputChange}
                                            >
                                                <option value="">Selecione o categoria</option>
                                                {categoryData.map((category) => (
                                                    <option key={category.id} value={category.id}>
                                                        {category.name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>

                                    <div className="w-full">
                                <label
                                    className="text-sm  dark:text-white ml-1.5 font-medium">Status</label>
                                <select
                                    className={`mt-2 flex h-12 w-full items-center justify-center rounded-xl border bg-white/0 p-3 text-sm outline-none dark:!border-white/10  ${
                                        formErrorData.status === "error" ? "border-red-500" : ""
                                    }`}
                                    id="status"
                                    value={formData.status}
                                    onChange={handleInputChange}
                                >
                                    <option value="">Selecione status</option>
                                    <option value="Ativo">Ativo</option>
                                    <option value="Inativo">Inativo</option>
                                </select>
                            </div>


                                </div>

                                {/* Modal Footer */}
                                <div className="flex items-center justify-end p-5 border-t border-solid border-slate-200 rounded-b">
                                    <button
                                        onClick={handleCancel}
                                        className="linear mt-2 w-48 rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200">
                                        Cancelar
                                    </button>
                                    <button
                                        onClick={handleSubmit}
                                        className="linear mt-2 w-48 rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200 ml-auto"
                                    >
                                        Salvar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/*overlay*/}
                    <div className="bg-black opacity-90 fixed inset-0 z-40 backdrop-blur-2xl backdrop-filter"></div>
                </>
            ) : null}
        </>
    );
};

export default FunctionsModal;
